import React from 'react'
import SliderLearn from '../../molecules/sliderLearn/sliderLearn'
import ArticleCard from '../../atoms/articleCard/articleCard'
import imagenRef from '../../../assets/images/learn/sofi.png'
import imagen1 from '../../../assets/images/learn/articulo1.png'
import imagen2 from '../../../assets/images/learn/articulo2.png'
import imagen3 from '../../../assets/images/learn/articulo3.png'
import imagen4 from '../../../assets/images/learn/articulo4.png'
import imagen5 from '../../../assets/images/learn/articulo5.png'
import imagen6 from '../../../assets/images/learn/articulo6.png'
import imagen7 from '../../../assets/images/learn/articulo7.png'
import imagen8 from '../../../assets/images/learn/articulo8.png'
import imagen9 from '../../../assets/images/learn/articulo9.png'

import './informativeArticles.scss'

function InformativeArticles() {

  const pushDataLayer = (Label) => {
    try {
      window.dataLayer.push({
        event: 'ga_event',
        category: 'Vive el Cole :: Artículos',
        action: 'Click',
        label: Label,
        value: '',
      })
    } catch (error) {
      console.log('Datalayer error:', error)
    }
  }
  const cards = [
    <ArticleCard
      onClick={() => pushDataLayer('¿Cómo impacta la menstruación en los adolescentes?')}
      title={'¿Cómo impacta la menstruación en los adolescentes?'}
      text={
        '¿Alguna vez te has preguntado qué haces si te llega la menstruación por primera vez? ¿Qué van a pensar los demás?'
      }
      image={imagen1}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/como-impacta-la-menstruacion-en-la-adolescencia-nosotras-colombia/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('¿Cómo cuidar la higiene íntima femenina?')}
      title={'¿Cómo cuidar la higiene íntima femenina?'}
      text={
        'Andrea Mejía Ríos, ginecóloga y obstetra, está aquí para hablarnos sobre la importancia de la higiene de nuestra Zona V, ¡toma papel y lápiz! '
      }
      image={imagen2}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/como-cuidar-la-higiene-intima-femenina-nosotras-online/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('Datos curiosos sobre los senos')}
      title={'Datos curiosos sobre los senos'}
      text={
        'Nuestros senos… tan hermosos, femeninos y diferentes. Durante nuestro proceso de crecimiento hemos pasado por diferentes etapas con ellos'
      }
      image={imagen3}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/datos-curiosos-sobre-los-senos/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('¿Para qué se utilizan los protectores diarios?')}
      title={'¿Para qué se utilizan los protectores diarios?'}
      text={
        'La Doctora Verónica Abad nos respondió algunas dudas que solemos tener alrededor de este tema, así que sin más rodeos ¡empecemos!'
      }
      image={imagen4}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/todas-tus-preguntas-sobre-para-que-se-utilizan-los-protectores-diarios/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('Ciclo menstrual: ¿Qué es? y ¿Cómo se calcula?')}
      title={'Ciclo menstrual: ¿Qué es? y ¿Cómo se calcula?'}
      text={
        'Te has preguntado ¿Por qué a una mujer le llega la menstruación? ¿Qué sucede en el cuerpo durante este tiempo para que este proceso suceda? '
      }
      image={imagen5}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/ciclo-menstrual-que-es-y-como-se-calcula/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('Aprende todo lo que debes saber sobre la Menstruación')}
      title={'Aprende todo lo que debes saber sobre la Menstruación'}
      text={
        'Sabemos que de todos los cambios que ocurren en nuestro cuerpo, este, ¡es uno de los que más dudas nos generan!'
      }
      image={imagen6}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/menstruacion-lo-que-debes-saber-en-nosotras-colombia/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('¿Cuánto dura el periodo?')}
      title={'¿Cuánto dura el periodo?'}
      text={
        'Preguntar sobre el periodo a nuestras amigas debería ser más normal de lo que creemos, en general ¡hablar del periodo debe ser más natural!'
      }
      image={imagen7}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/cuanto-dura-el-periodo-testimonios-y-experiencias-nosotras-colombia/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('Lo que debes saber para tener una buena relación con tu periodo')}
      title={'Lo que debes saber para tener una buena relación con tu periodo'}
      text={
        'La menstruación ocurre debido a los cambios que sufren las hormonas del cuerpo femenino...'
      }
      image={imagen8}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/aprende-como-tener-una-buena-relacion-con-tu-menstruacion/'
      }
    />,
    <ArticleCard
      onClick={() => pushDataLayer('¿Cómo funciona tu ciclo menstrual?')}
      title={'¿Cómo funciona tu ciclo menstrual?'}
      text={
        'La menstruación representa los años fértiles de la vida de la mujer que se inician en la adolescencia y duran hasta la menopausia. '
      }
      image={imagen9}
      url={
        'https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/como-funciona-tu-ciclo-menstrual/'
      }
    />,
  ]

  return (
    <div className='informative-articles'>
      <div className='informative-articles__wrapper'>
        <div className='informative-articles__title'>
          <h2>Artículos informativos</h2>
        </div>
        <div className='informative-articles__slider'>
          <SliderLearn elements={cards} />
        </div>
      </div>
    </div>
  )
}

export default InformativeArticles
